import {mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'user'
        ]),
        isManager() {
            return this.user && this.user.isManager;
        },
        mobile() {
            return this.user && this.user.mobile;
        }
    },
    created() {
        if (!this.isManager) {
            this.$router.push({name: 'stations'});
        }
    }
}